import { OnInit, Component, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { CDSMask } from '@app/utils/cds-mask';

import { DivisaoHonorarios, DivisaoHonorariosAdvogado } from '@app/pages/financeiro/financeiro-processo/financeiro-processo.model';
import { Processo } from '@app/models/processo.model';

import { FinanceiroProcessoService } from '@app/services/financeiro-processo.service';

import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { INgxSelectOption } from 'ngx-select-ex';
import { UtilitarioService } from '@app/services/utilitario.service';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RequisicaoFinanceira } from '@app/models/requisicao-financeira.model';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-financeiro-processo-form',
  templateUrl: './financeiro-processo-form.component.html',
})
export class FinanceiroProcessoFormComponent implements OnInit {
  objetoRequisicao: any;

  aguardandoSolicitacao = false;
  participanteNome: string;
  descricao: string;
  cdsMask: CDSMask = new CDSMask();
  lstErros: string[];

  divisaoHonorarios: DivisaoHonorarios = new DivisaoHonorarios();
  processo: Processo = new Processo();

  lstAdvogados: IdDescricao[];
  lstTipoDRReceita: IdDescricao[];
  lstTipoDRDespesa: IdDescricao[];

  valorSubstabelecido = 0;
  valorDespesas = 0;
  valorCliente = 0;
  valorEscritorio = 0;
  // valorAdvogados = new Array<number>();

  constructor(
    private route: ActivatedRoute,
    @Inject(ToastrService) private toastr: ToastrService,
    private router: Router,
    private consultasService: ConsultasService,
    private financeiroProcessoService: FinanceiroProcessoService) {
  }

  ngOnInit() {
    this.consultasService.consultar('ADVOGADO').toPromise().then(data => this.lstAdvogados = data);
    this.consultasService.consultar('DR_D').toPromise().then(data => this.lstTipoDRDespesa = data);
    this.consultasService.consultar('DR_R').toPromise().then(data => this.lstTipoDRReceita = data);

    this.divisaoHonorarios.VencimentoInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);

    //tratativa para divisão gerada por RequisicaoFinanceira (RPV/Precatório)
    this.route.params
    .pipe(
      map((params) => params['requisicaofinanceiraid']),
      switchMap((requisicaoFinanceiraId) => this.financeiroProcessoService.obterRequisicaoFinanceiraPorId(requisicaoFinanceiraId))
    )
    .subscribe(
      (requisicaoFinanceira) => { 
        this._preencheDivisaoPorRequisicao(requisicaoFinanceira);
        //buscar informações do proceso
          this.route.parent.params
          .subscribe(
            (parentParams) => {
              const processoId = parentParams['id'];
              this._buscaProcesso(processoId, requisicaoFinanceira !== null);
            }
          )
      }
    );
  }

  private _preencheDivisaoPorRequisicao(requisicao: RequisicaoFinanceira){
    if(requisicao === null || requisicao === undefined)
      return;
    
    this.divisaoHonorarios.ValorTotal = requisicao.Valor;
    this.divisaoHonorarios.ValorPorcentualCliente = requisicao.PercentualCliente;
    this.divisaoHonorarios.ValorPorcentualEscritorio = requisicao.PercentualEscritorio;
    this.divisaoHonorarios.ValorPorcentualSubstabelecido = requisicao.PercentualSubstabelecido ?? 0;
    this.divisaoHonorarios.ValorPercentualPrevisaoDespesa = requisicao.PercentualEncaminhador ?? 0;
    
    requisicao.HonorariosAdvogados.forEach(
      reqAdv => {
        const adv = new DivisaoHonorariosAdvogado();
        adv.AdvogadoId = reqAdv.AdvogadoId;
        adv.ValorPorcentual =  reqAdv.PercentualAdvogado;
        this.divisaoHonorarios.DivisaoHonorariosAdvogado.push(adv);
      });

      this.atualizaValores();
  }

  private _buscaProcesso(id: number, requisicao: boolean) {
    this.financeiroProcessoService.obterProcesso(id).subscribe(
      data => {
        this._preencheInformacoesDoProcesso(data);
        this._preencheSeNaoHouverRequisicao(requisicao);
      });
  }

  private _preencheInformacoesDoProcesso(data: any) {
    this.processo = data;
    this.divisaoHonorarios.ClienteId = this.processo.ClienteId;
    this.divisaoHonorarios.SubstabelecidoId = this.processo.SubstabelecidoPor;
    this.divisaoHonorarios.PrevisaoDespesaParticipanteId = this.processo.EncaminhadoPor;
    this.divisaoHonorarios.ProcessoId = this.processo.Id;

    this.divisaoHonorarios.ClienteNome = this.processo.ClienteNome;
    this.divisaoHonorarios.Descricao = this.processo.ClienteNome + ' (' + this.processo.Ficha + ')' +
      ' X ' + this.processo.ParteContraria;
    this.divisaoHonorarios.PrestacaoDeContas = false;
  }

  private _preencheSeNaoHouverRequisicao(requisicao: boolean) {
    if(requisicao)
      return;
    
    this.divisaoHonorarios.ValorPorcentualCliente = this.processo.ValorPorcentualCliente;
    this.divisaoHonorarios.ValorPorcentualEscritorio = this.processo.ValorPorcentualEscritorio;

    this.processo.ProcessoAdvogado.forEach(advogado => {
      const adv = new DivisaoHonorariosAdvogado();
      adv.AdvogadoId = advogado.AdvogadoId;
      this.divisaoHonorarios.DivisaoHonorariosAdvogado.push(adv);
    });
  }

  adicionarAdvogado() {
    const adv = new DivisaoHonorariosAdvogado();
    adv.AdvogadoId = 0;
    adv.Desbloqueado = true;
    this.divisaoHonorarios.DivisaoHonorariosAdvogado.push(adv);
  }

  removerAdvogado(index: number) {
    this.divisaoHonorarios.DivisaoHonorariosAdvogado.splice(index, 1);
  }

  adicionar() {
    this.aguardandoSolicitacao = true;
    this.financeiroProcessoService.adicionar(this.divisaoHonorarios)
      .toPromise().then(
        () => {
          this.router.navigate(['/processos/processo', this.processo.Id,'financeiro']);
        },
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          }
          this.aguardandoSolicitacao = false;
        });
  }

  searchCallback = (search: string, item: INgxSelectOption) => {
    if (search.trim() === '') {
      return true;
    } else {
      return item.text && item.text.toLowerCase().includes(search.toLowerCase());
    }
  }

  atualizaValores() {
    this.sanitizar();
    this.valorSubstabelecido = this.divisaoHonorarios.ValorTotal * this.divisaoHonorarios.ValorPorcentualSubstabelecido * 0.01;
    this.valorEscritorio = this.divisaoHonorarios.ValorTotal * this.divisaoHonorarios.ValorPorcentualEscritorio * 0.01;
    this.valorCliente = this.divisaoHonorarios.ValorTotal * this.divisaoHonorarios.ValorPorcentualCliente * 0.01;
    this.valorDespesas = this.valorEscritorio * this.divisaoHonorarios.ValorPercentualPrevisaoDespesa * 0.01;
  }

  completaCliente() {
    this.sanitizar();
    this.divisaoHonorarios.ValorPorcentualCliente = Number((100 - this.divisaoHonorarios.ValorPorcentualEscritorio).toFixed(2));
  }

  completaEscritorio() {
    this.sanitizar();
    this.divisaoHonorarios.ValorPorcentualEscritorio = Number((100 - this.divisaoHonorarios.ValorPorcentualCliente).toFixed(2));
  }

  sanitizar(): void {
    if (this.divisaoHonorarios.ValorPorcentualCliente.toString().indexOf(','))
      this.divisaoHonorarios.ValorPorcentualCliente = Number(this.divisaoHonorarios.ValorPorcentualCliente.toString().replace(',', '.'));
    if (this.divisaoHonorarios.ValorPorcentualEscritorio.toString().indexOf(','))
      this.divisaoHonorarios.ValorPorcentualEscritorio = Number(this.divisaoHonorarios.ValorPorcentualEscritorio.toString().replace(',', '.'));
    if (this.divisaoHonorarios.ValorPorcentualSubstabelecido.toString().indexOf(','))
      this.divisaoHonorarios.ValorPorcentualSubstabelecido = Number(this.divisaoHonorarios.ValorPorcentualSubstabelecido.toString().replace(',', '.'));
    if (this.divisaoHonorarios.ValorPercentualPrevisaoDespesa.toString().indexOf(','))
      this.divisaoHonorarios.ValorPercentualPrevisaoDespesa = Number(this.divisaoHonorarios.ValorPercentualPrevisaoDespesa.toString().replace(',', '.'));

  }

}
